export default function TextLinkButton({ onClick, children }) {
  return (
    <>
      <button className="text-link-button" onClick={onClick}>
        {children}
      </button>
    </>
  );
}
